import axios from 'axios';

const API = axios.create({ baseURL: '/api' });

export const api = {
  // Dashboard
  getDashboard: () => API.get('/dashboard/'),
  
  // Animals
  getAnimals: (params?: any) => API.get('/animals/', { params }),
  getAnimal: (id: number) => API.get(`/animals/${id}/`),
  createAnimal: (data: any) => API.post('/animals/', data),
  updateAnimal: (id: number, data: any) => API.patch(`/animals/${id}/`, data),
  deleteAnimal: (id: number) => API.delete(`/animals/${id}/`),
  
  // Actions
  addWeight: (id: number, data: any) => API.post(`/animals/${id}/add_weight/`, data),
  addFeed: (id: number, data: any) => API.post(`/animals/${id}/add_feed/`, data),
  addHealth: (id: number, data: any) => API.post(`/animals/${id}/add_health/`, data),
  generateRecommendation: (id: number, data?: any) => API.post(`/animals/${id}/generate_recommendation/`, data || {}),
  getWeightHistory: (id: number) => API.get(`/animals/${id}/weight_history/`),
  bulkRecommend: () => API.post('/bulk-recommend/'),
};

export default api;
